<mat-dialog-actions class="justify-content-between">
  <h3 *ngIf="!viewOnly">{{ 'PHARMACY.ADD_BATCH' | translate }} - {{ drugName }}</h3>
  <h3 *ngIf="viewOnly">{{ 'PHARMACY.VIEW_BATCHES' | translate }} - {{ drugName }}</h3>
  <button mat-icon-button mat-dialog-close class="d-flex justify-content-center">
    <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
  </button>
</mat-dialog-actions>
<mat-divider></mat-divider>
<mat-dialog-content class="mat-typography">

  <!-- View Only: Batch List Table -->
  <div *ngIf="viewOnly">
    <table mat-table [dataSource]="batches" class="w-100" *ngIf="batches.length > 0">
      <ng-container matColumnDef="batchNo">
        <th mat-header-cell *matHeaderCellDef class="f-s-14 f-w-600">
          {{ 'PHARMACY.BATCH_NO' | translate }}
        </th>
        <td mat-cell *matCellDef="let element" class="f-s-14">
          {{ element.batchNo }}
        </td>
      </ng-container>

      <ng-container matColumnDef="expiryDate">
        <th mat-header-cell *matHeaderCellDef class="f-s-14 f-w-600">
          {{ 'PHARMACY.EXPIRY_DATE' | translate }}
        </th>
        <td mat-cell *matCellDef="let element" class="f-s-14">
          {{ element.expiryDate | date:'MM/yyyy' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef class="f-s-14 f-w-600">
          {{ 'PHARMACY.QTY' | translate }}
        </th>
        <td mat-cell *matCellDef="let element" class="f-s-14">
          {{ element.quantity }}
        </td>
      </ng-container>

      <ng-container matColumnDef="purchasePrice">
        <th mat-header-cell *matHeaderCellDef class="f-s-14 f-w-600">
          {{ 'PHARMACY.PURCHASE_PRICE' | translate }}
        </th>
        <td mat-cell *matCellDef="let element" class="f-s-14">
          <span *ngIf="element.purchasePrice !== null">
            {{ element.purchasePrice | indianCurrency }}
          </span>
          <span *ngIf="element.purchasePrice === null">-</span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="batchDisplayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: batchDisplayedColumns"></tr>
    </table>

    <div *ngIf="batches.length === 0" class="text-center m-t-20 m-b-20">
      <p class="f-s-16 f-w-600">{{ 'PHARMACY.NO_BATCHES' | translate }}</p>
    </div>
  </div>

  <!-- Add Mode: Form -->
  <form *ngIf="!viewOnly" [formGroup]="batchForm">
    <div class="row">
      <div class="col-lg-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'PHARMACY.DRUG_NAME' | translate }}</mat-label>
          <input matInput [value]="drugName" readonly />
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'PHARMACY.BATCH_NO' | translate }}</mat-label>
          <input matInput formControlName="batchNo" placeholder="{{ 'PHARMACY.BATCH_NO' | translate }}" />
          <mat-error *ngIf="batchForm.get('batchNo')?.hasError('required')">
            {{ 'REQUIRED.NAME' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-lg-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'PHARMACY.EXPIRY_DATE' | translate }}</mat-label>
          <input matInput [matDatepicker]="expiryPicker" formControlName="expiryDate" [min]="minDate" />
          <mat-datepicker-toggle matSuffix [for]="expiryPicker"></mat-datepicker-toggle>
          <mat-datepicker #expiryPicker></mat-datepicker>
          <mat-error *ngIf="batchForm.get('expiryDate')?.hasError('required')">
            {{ 'REQUIRED.SELECT_DATE' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'PHARMACY.QTY' | translate }}</mat-label>
          <input type="number" matInput formControlName="quantity" min="1"
            placeholder="{{ 'PHARMACY.QTY' | translate }}" />
          <mat-error *ngIf="batchForm.get('quantity')?.hasError('required')">
            {{ 'REQUIRED.NAME' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-lg-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'PHARMACY.PURCHASE_PRICE' | translate }}</mat-label>
          <input type="number" matInput formControlName="purchasePrice"
            placeholder="{{ 'PHARMACY.PURCHASE_PRICE' | translate }}" />
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'PHARMACY.SELLING_PRICE_MRP' | translate }}</mat-label>
          <input type="number" matInput formControlName="sellingPrice"
            placeholder="{{ 'PHARMACY.SELLING_PRICE_MRP' | translate }}" />
        </mat-form-field>
      </div>
    </div>

  </form>

</mat-dialog-content>
<mat-divider *ngIf="!viewOnly"></mat-divider>
<mat-dialog-actions *ngIf="!viewOnly">
  <div class="row p-r-16 w-100">
    <div class="col-lg-8"></div>
    <div class="col-lg-4 d-flex justify-content-end">
      <button mat-stroked-button class="m-r-5" (click)="onClose()">
        {{ 'BUTTON.BTN_CLOSE' | translate }}
      </button>
      <button mat-flat-button color="primary" class="m-l-4" (click)="onSave()" [disabled]="batchForm.invalid">
        {{ 'BUTTON.BTN_SAVE' | translate }}
      </button>
    </div>
  </div>
</mat-dialog-actions>